<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @ok="moveUnit"
        >
            <template #modal-title>
                <div class="d-flex w-100 align-items-center">
                    <span v-if="publication_is_trunk_boolean">
                        Import Duplicate <span v-if="import_level == 'unit'">Week</span><span v-else>Unit</span> From Existing Publications
                    </span>
                    <span v-else>
                        Import <span v-if="import_level == 'unit'">Week</span><span v-else>Unit</span> From Trunk Publication
                    </span>
                </div>

            </template>

            <div class="mb-4">
                <b-input-group>

                    <template #prepend>
                        <b-input-group-prepend is-text><div>Search By:</div></b-input-group-prepend>

                    <b-dropdown :text="search_by" variant="info" v-model="search_by">
                        <b-dropdown-item v-for="type_of_search in search_types" @click="search_by = type_of_search">{{ type_of_search }}</b-dropdown-item>
                    </b-dropdown>
                    </template>

                    <b-form-input v-model="search_term" @change="searchForTrunkUnits"></b-form-input>

                    <template #append>
                        <b-button variant="outline-primary" @click="searchForTrunkUnits">Search</b-button>
                    </template>
                </b-input-group>
            </div>

            <div v-if="searching_for_results">
                <b-spinner label="Loading..."></b-spinner>
            </div>

            <div v-if="searched_units && searched_units.length > 0">
                <b-card v-for="unit_to_copy in searched_units" class="mb-3">
                    <b-card-header>
                        <div>
                            <template v-if="import_level == 'unit'">Week Title: {{ unit_to_copy.title }}</template>
                            <template v-else>Unit Title: {{ unit_to_copy.unit_group_title }}</template>
                        </div>
                    </b-card-header>
                    <b-card-body>
                        <div class="row">
                            <template v-if="import_level == 'unit'">
                            <div class="col">
                                <div>
                                    <template v-if="import_level == 'unit'">Week Info: </template>
                                    <template v-else>Unit Info: </template>
                                </div>
                                <div class="alert alert-success mb-1 small"><span v-if="!publication_is_trunk_boolean">Trunk</span> SKU: {{ unit_to_copy.sku }}</div>
                                <div class="alert alert-success mb-1 small">Unit Number: {{ unit_to_copy.unit_group_order }}</div>
                                <div class="alert alert-success mb-1 small">Week Number: {{ unit_to_copy.order_number }}</div>
                                <div class="alert alert-success mb-1 small">Week ID: {{ unit_to_copy.id }}</div>
                                <div class="alert alert-success mb-1 small">Week Title: {{ unit_to_copy.title }}</div>
                                <div class="alert alert-success mb-1 small">Week Description: <span v-html="unit_to_copy.description"></span></div>
                            </div>
                            <div class="col">
                                <div>Articles:</div>
                                <div v-for="article in unit_to_copy.articles">
                                    <div class="alert alert-primary mb-1 small" role="alert">{{ article.id  }}: {{ article.title }}</div>
                                </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="col">
                                    <div>Unit Info:</div>
                                    <div class="alert alert-success mb-1 small"><span v-if="!publication_is_trunk_boolean">Trunk</span> SKU: {{ unit_to_copy.sku }}</div>
                                    <div class="alert alert-success mb-1 small">Unit Number: {{ unit_to_copy.order_number }}</div>
                                    <div class="alert alert-success mb-1 small">Unit Title: <span v-if="unit_to_copy.title">{{ unit_to_copy.title }}</span><span v-else>No Title</span></div>
                                    <div class="alert alert-success mb-1 small">Unit Description: <span v-html="unit_to_copy.description"></span></div>
                                    <div class="alert alert-success mb-1 small">Unit ID: {{ unit_to_copy.id }}</div>
                                </div>
                                <div class="col">
                                    <div>Weeks:</div>
                                    <div v-if="unit_to_copy.units.length > 0" v-for="child_unit in unit_to_copy.units">
                                        <div class="alert alert-primary mb-1 small" role="alert">{{ child_unit.id  }}: <span v-if="child_unit.title">{{ child_unit.title }}</span><span v-else>No Title</span></div>
                                    </div>
                                    <div v-if="unit_to_copy.units.length < 1">
                                        <div class="alert alert-danger mb-1 small" role="alert">Unit contains no weeks</div>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </b-card-body>
                    <b-card-footer>
                        <b-button
                        v-if="import_level == 'unit'"
                        class="btn-success"
                        @click="importSelectedWeek(unit_to_copy)">
                            Import Week
                        </b-button>
                        <b-button
                        v-else
                        :disabled="importing_unit_group"
                        class="btn-success"
                        @click="importSelectedUnit(unit_to_copy)">
                            Import Unit
                            <span v-if="importing_unit_group">
                                <b-spinner label="Loading..."></b-spinner>
                            </span>
                        </b-button>
                    </b-card-footer>

                </b-card>
            </div>

            <div v-if="searched_unit_groups && searched_unit_groups.length > 0">
                <b-card v-for="unit_to_copy in searched_unit_groups" class="mb-3">
                    <b-card-header>
                        <div>Unit Title: {{ unit_to_copy.title }}</div>
                    </b-card-header>
                    <b-card-body>
                        <div class="row">
                            <template v-if="import_level == 'unit'">
                            <div class="col">
                                <div>Unit Info:</div>
                                <div class="alert alert-success mb-1 small"><span v-if="!publication_is_trunk_boolean">Trunk</span> SKU: {{ unit_to_copy.sku }}</div>
                                <div class="alert alert-success mb-1 small">Unit Number: {{ unit_to_copy.unit_group_order }}</div>
                                <div class="alert alert-success mb-1 small">Week Number: {{ unit_to_copy.order_number }}</div>
                                <div class="alert alert-success mb-1 small">Week ID: {{ unit_to_copy.id }}</div>
                                <div class="alert alert-success mb-1 small">Week Title: {{ unit_to_copy.title }}</div>
                                <div class="alert alert-success mb-1 small">Week Description: <span v-html="unit_to_copy.description"></span></div>
                            </div>
                            <div class="col">
                                <div>Articles:</div>
                                <div v-for="article in unit_to_copy.articles">
                                    <div class="alert alert-primary mb-1 small" role="alert">{{ article.id  }}: {{ article.title }}</div>
                                </div>
                            </div>
                            </template>
                            <template v-else>
                                <div class="col">
                                    <div>Unit Info:</div>
                                    <div class="alert alert-success mb-1 small"><span v-if="!publication_is_trunk_boolean">Trunk</span> SKU: {{ unit_to_copy.sku }}</div>
                                    <div class="alert alert-success mb-1 small">Unit Number: {{ unit_to_copy.order_number }}</div>
                                    <div class="alert alert-success mb-1 small">Unit Title: <span v-if="unit_to_copy.title">{{ unit_to_copy.title }}</span><span v-else>No Title</span></div>
                                    <div class="alert alert-success mb-1 small">Unit Description: <span v-html="unit_to_copy.description"></span></div>
                                    <div class="alert alert-success mb-1 small">Unit ID: {{ unit_to_copy.id }}</div>
                                </div>
                                <div class="col">
                                    <div>Weeks:</div>
                                    <div v-if="unit_to_copy.units.length > 0" v-for="child_unit in unit_to_copy.units">
                                        <div class="alert alert-primary mb-1 small" role="alert">{{ child_unit.id  }}: <span v-if="child_unit.title">{{ child_unit.title }}</span><span v-else>No Title</span></div>
                                    </div>
                                    <div v-if="unit_to_copy.units.length < 1">
                                        <div class="alert alert-danger mb-1 small" role="alert">Unit contains no weeks</div>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </b-card-body>
                    <b-card-footer>
                        <b-button
                        v-if="import_level == 'unit'"
                        class="btn-success"
                        @click="importSelectedWeek(unit_to_copy)">
                            Import Week
                        </b-button>
                        <b-button
                        v-else
                        :disabled="importing_unit_group"
                        class="btn-success"
                        @click="importSelectedUnit(unit_to_copy)">
                            Import Unit
                            <span v-if="importing_unit_group">
                                <b-spinner label="Loading..."></b-spinner>
                            </span>
                        </b-button>
                    </b-card-footer>

                </b-card>
            </div>

            <b-card v-if="search_failed || (searched_units && searched_units.length == 0)" class="mb-3">
                The week searched does not exist.
            </b-card>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

// import Vue from 'vue'
import { mapState } from 'vuex'

export default {
    data: () => ({
        lookup_unit_id: null,
        lookup_unit_title: null,
        lookup_publication_sku: null,
        unit_to_copy: null,
        searching_for_results: false,
        search_term: '',
        search_failed: false,
        searched_units: null,
        searched_unit_groups: null,
        search_by: 'SKU',
        search_types: ['SKU', 'Title', 'ID' ],
        importing_unit_group: false,
    }),
    props: [
        'value',
        'publication_is_trunk',
        'publication_id',
        'unit_group',
        'import_level' //unit_group or unit
    ],
    computed: {
        ...mapState({

        }),
        modal_id () {
            let modal_id = null

            if (this.unit_group && this.unit_group.id) {
                modal_id = 'trunk-import-unit-modal' + this.unit_group.id
            }
            else{
                modal_id = 'trunk-import-unit-group-modal' + this.publication_id;
            }

            return modal_id
        },
        publication_is_trunk_boolean() {
            return parseInt(this.publication_is_trunk) === 1 || this.publication_is_trunk === 'true';
        },

    },
    methods: {
        searchForTrunkUnits(){
            if(!this.search_term || this.search_term == '' || this.searching_for_results){
                return false;
            }

            if(this.import_level == 'unit'){
                if(this.search_by == 'SKU'){
                    this.getTrunkUnitsBySku();
                }
                else if(this.search_by == 'Title'){
                    this.getTrunkUnitsByTitle();
                }
                else{
                    this.getTrunkUnitByUnitId();
                }
            }
            else{
                if(this.search_by == 'SKU'){
                    this.getTrunkUnitGroupsBySku();
                }
                else if(this.search_by == 'Title'){
                    this.getTrunkUnitGroupsByTitle();
                }
                else{
                    this.getTrunkUnitGroupByUnitGroupId();
                }
            }
        },
        async getTrunkUnitByUnitId() {
            this.searching_for_results = true
            let url = `/api/units/get_units/${this.search_term}${this.publication_is_trunk_boolean ? '?trunk=0' : ''}`
            this.search_failed = false
            const response = await this.axios.get(url)
            if (response.data.searched_units.length > 0) {
                this.searched_units = response.data.searched_units
                this.searching_for_results = false
            } else {
                this.searched_units = null
                this.search_failed = true
                this.searching_for_results = false
            }
        },
        async getTrunkUnitsByTitle() {
            this.searching_for_results = true
            let url = `/api/units/get_units_by_title/${this.search_term}${this.publication_is_trunk_boolean ? '?trunk=0' : ''}`
            this.search_failed = false
            const response = await this.axios.get(url)
            if (response.data.searched_units.length > 0) {
                this.searched_units = response.data.searched_units
                this.searching_for_results = false
            } else {
                this.searched_units = null
                this.search_failed = true
                this.searching_for_results = false
            }
        },
        async getTrunkUnitsBySku() {
            this.searching_for_results = true
            let url = `/api/units/get_units_by_publication_sku/${this.search_term}${this.publication_is_trunk_boolean ? '?trunk=0' : ''}`
            this.search_failed = false
            const response = await this.axios.get(url)
            if (response.data.searched_units.length > 0) {
                this.searched_units = response.data.searched_units
                this.searching_for_results = false
            } else {
                this.searched_units = null
                this.search_failed = true
                this.searching_for_results = false
            }
        },
        getTrunkUnitGroupByUnitGroupId(){
            this.searching_for_results = true;
            let url = this.publication_is_trunk_boolean ? '/api/unit_groups/get_existing_unit_group/'+ this.search_term : '/api/unit_groups/get_trunk_unit_group/'+ this.search_term;
            this.search_failed = false;
            this.axios.get(url)
            .then(response => {
                if(response.data.searched_unit_groups.length > 0){
                    this.searched_unit_groups = response.data.searched_unit_groups;
                    this.searching_for_results = false;
                }else{
                    this.searched_unit_groups = null;
                    this.search_failed = true;
                    this.searching_for_results = false;
                }
            })
        },
        getTrunkUnitGroupsByTitle(){
            this.searching_for_results = true;
            let url = this.publication_is_trunk_boolean ? '/api/unit_groups/get_existing_unit_groups_by_title/'+ this.search_term : '/api/unit_groups/get_trunk_unit_groups_by_title/'+ this.search_term;

            this.search_failed = false;
            this.axios.get(url)
            .then(response => {
                console.log('response.data.searched_unit_groups', response.data.searched_unit_groups, this.publication);
                if(response.data.searched_unit_groups.length > 0){
                    this.searched_unit_groups = response.data.searched_unit_groups;
                    this.searching_for_results = false;

                }else{
                    this.searched_unit_groups = null;
                    this.search_failed = true;
                    this.searching_for_results = false;
                }
            })
        },
        getTrunkUnitGroupsBySku(){
            this.searching_for_results = true;
            let url = this.publication_is_trunk_boolean ? '/api/unit_groups/get_existing_unit_groups_by_publication_sku/'+ this.search_term : '/api/unit_groups/get_trunk_unit_groups_by_publication_sku_for_import_to_branch/'+ this.search_term;
            this.search_failed = false;
            this.axios.get(url)
            .then(response => {
                console.log(response.data);

                if(response.data.searched_unit_groups.length > 0){
                    this.searched_unit_groups = response.data.searched_unit_groups;
                    this.searching_for_results = false;

                }else{
                    this.searched_unit_groups = null;
                    this.search_failed = true;
                    this.searching_for_results = false;
                }
            })
        },
        async importSelectedWeek(trunk_unit) {
            try {
                await this.axios.post('/api/units/import_trunk_unit_into_unit_group', {
                    trunk_unit_id: trunk_unit.id,
                    trunk_unit_group_id: trunk_unit.trunk_unit_group_id,
                    trunk_publication_id: trunk_unit.trunk_publication_id,
                    target_unit_group_id: this.unit_group.id,
                    target_publication_id: this.publication_id,
                });
            } catch (e) {

            } finally {
                this.resetForm()
                this.$emit('getUnits')
                this.$emit('hide')
            }
        },
        importSelectedUnit(unit_to_copy){

            this.importing_unit_group = true;
            this.axios.post('/api/unit_groups/import_trunk_unit_group_into_publication/'+ unit_to_copy.id +'/'+this.publication_id+'/'+unit_to_copy.publication_id)
            .then(response => {
                console.log(response.data);
                this.resetForm();
                this.$emit('getUnitGroups');
                this.$emit('hide');
                this.importing_unit_group = false;
            })
        },
        resetForm(){
            this.lookup_unit_id = null;
            this.lookup_unit_title = null;
            this.lookup_publication_sku = null;
            this.unit_to_copy = null;
            this.search_term = '';
            this.search_failed = false;
            this.searched_units = null;
        },
        moveUnit () {

        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide() {
            this.resetForm();
            this.$emit('hide')
        },
        hidden () {
            this.resetForm();
            this.$emit('hide')
        }
    }
}
</script>
